import type { ChallengesDrawer } from '../types';

export function ChallengesDrawerOverflowCard(props: ChallengesDrawer) {
  return <div>{props.data.challengeId}</div>;
}
